<!-- The Modal-->
<div class="modal" id="regStudentModal">
    <div class="modal-dialog">
      <div class="modal-content">

        <!-- Modal Header -->
        <div class="modal-header gold-bg">
          <h4 class="modal-title">
            <span class="glyphicon glyphicon-lock"></span>
            Register  New Student
            </h4>
          <button type="button" class="btn btn-danger" (click)="closeModal()">&times;</button>
        </div>

        <!-- Modal body -->
        <div class="modal-body">
          <form [formGroup] = "myForm" (ngSubmit)="on_submit()" class="form" enctype="multipart/form-data" id="register-student-from">
            <div class="form-group row mt-2" [ngClass]="{error:f.firstName.errors && f.firstName.touched}">
              <label for="subjectId" class='control-label col-sm-3' >First Name</label>
                  <div class="col-sm-9"><input  id="firstName" formControlName="firstName" class='form-control'></div>
                  <div *ngIf="f.firstName.errors && f.firstName.touched" style="color:red;float: left;width: 100%;background: #ff000014;margin-top: 10px;padding: 10px 2px 0px 1px;">
                    <ul>
                        <li>First Name Required.</li>
                    </ul>
                </div>
            </div>
            <div class="form-group row mt-2" [ngClass]="{error:f.lastName.errors && f.lastName.touched}">
                <label for="subjectId" class='control-label col-sm-3' >Last Name</label>
                    <div class="col-sm-9"><input id="lastName" formControlName="lastName" class='form-control'></div>
                    <div *ngIf="f.lastName.errors && f.lastName.touched" style="color:red;float: left;width: 100%;background: #ff000014;margin-top: 10px;padding: 10px 2px 0px 1px;">
                      <ul>
                          <li>Last Name Required.</li>
                      </ul>
                  </div>
              </div>
              <div class="form-group row" [ngClass]="{error:f.country.errors && f.country.touched}">
                <label for="country" class='control-label col-sm-3'>Country of Residence<span class="required-asteric">*</span></label>
                    <div class="input-group controls col-sm-8">
                        <select class="form-control" id="country"  #myCountry formControlName="country">
                            <option *ngFor="let country of countries" [value]="country.id">{{country.name}}</option>
                        </select>
                        <div *ngIf="f.country.errors && f.country.touched" style="color:red;float: left;width: 100%;background: #ff000014;margin-top: 10px;padding: 10px 2px 0px 1px;">
                            <ul>
                                <li>Country  is required.</li>
                            </ul>
                        </div>
                    </div>
            </div>

            <div class="form-group row" [ngClass]="{error:f.curriculum.errors && f.curriculum.touched}">
              <label for="curriculum" class='control-label col-sm-3'>Curriculum<span class="required-asteric">*</span></label>
                  <div class="input-group controls col-sm-8">
                      <select class="form-control" id="curriculum"  #myCurriculum formControlName="curriculum"
                      (change)='onCurriculumOptionsSelected(myCurriculum.value)'>
                          <option *ngFor="let curriculum of curriculums" [value]="curriculum.id">{{curriculum.name}}</option>
                      </select>
                      <div *ngIf="f.curriculum.errors && f.curriculum.touched" style="color:red;float: left;width: 100%;background: #ff000014;margin-top: 10px;padding: 10px 2px 0px 1px;">
                          <ul>
                              <li>Curriculum  is required.</li>
                          </ul>
                      </div>
                  </div>
          </div>


            <div class="form-group row" [ngClass]="{error:f.level.errors && f.level.touched}" *ngIf="levels.length>0">
              <label for="level" class='control-label col-sm-3'>Level<span class="required-asteric">*</span></label>
                  <div class="input-group controls col-sm-8">
                      <select class="form-control" id="level"  #myLevel formControlName="level"
                      (change)='onLevelOptionsSelected(myLevel.value)'>>
                          <option *ngFor="let level of levels" [value]="level.id">{{level.name}}</option>
                      </select>
                      <div *ngIf="f.level.errors && f.level.touched" style="color:red;float: left;width: 100%;background: #ff000014;margin-top: 10px;padding: 10px 2px 0px 1px;">
                          <ul>
                              <li>Level  is required.</li>
                          </ul>
                      </div>
                  </div>
          </div>

    <fieldset class="buttons text-center">
    <button [disabled]="registering" type="submit" class="btn btn-primary margin-50-right">
      <span *ngIf="registering" class="spinner-border spinner-border-sm me-1"></span>
      Submit</button>
      <button type="button" class="btn btn-danger" (click)="closeModal()">Close</button>
    </fieldset>
    </form>
  </div>
</div>
</div>
</div>

